import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';
import toast from 'react-hot-toast';

const FavoriteButton = ({ projectId, projectTitle }) => {
  const { isAuthenticated } = useAuth();
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      checkFavoriteStatus();
    }
  }, [projectId, isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkFavoriteStatus = async () => {
    try {
      const response = await axios.get(`/api/projects/${projectId}/favorite-status`);
      setIsFavorite(response.data.isFavorite);
    } catch (error) {
      console.error('Erreur vérification favori:', error);
    }
  };

  const handleToggleFavorite = async () => {
    if (!isAuthenticated) {
      toast.error('Vous devez être connecté pour ajouter aux favoris');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`/api/projects/${projectId}/favorite`);
      setIsFavorite(response.data.isFavorite);
      
      if (response.data.isFavorite) {
        toast.success('Projet ajouté aux favoris !');
      } else {
        toast.success('Projet retiré des favoris');
      }
    } catch (error) {
      console.error('Erreur toggle favori:', error);
      toast.error(error.response?.data?.message || 'Erreur lors de la gestion des favoris');
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <button
        onClick={() => toast.error('Connectez-vous pour ajouter aux favoris')}
        className="flex items-center space-x-2 px-4 py-2 bg-gray-200 text-gray-600 rounded-lg hover:bg-gray-300 transition-colors"
        title="Connectez-vous pour ajouter aux favoris"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
        <span>Favori</span>
      </button>
    );
  }

  return (
    <button
      onClick={handleToggleFavorite}
      disabled={loading}
      className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
        isFavorite
          ? 'bg-red-100 text-red-600 hover:bg-red-200'
          : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
      } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
      title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
    >
      <svg 
        className={`w-4 h-4 ${isFavorite ? 'fill-current' : ''}`} 
        fill={isFavorite ? 'currentColor' : 'none'} 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
      <span>{isFavorite ? 'Favori' : 'Ajouter'}</span>
      {loading && (
        <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-current"></div>
      )}
    </button>
  );
};

export default FavoriteButton;

